/**
 * The brandbook's sizing ramp: the lockup's frame height, and the square and corner the tile and
 * `Logo.Well` draw at the same step. Written out as whole class strings so Tailwind can see them.
 *
 * The corner is half the square, squircled, as Prism's tiles are. The control radii name that corner
 * at 24, 32, 40 and 96; 56 and 72 fall between, so they are written as their half.
 */
export const HIGHLIGHT_LOGO_SIZES = {
  xs: { height: 24, box: 'size-6', radius: 'rounded-[var(--radius-size-sm)]' },
  sm: { height: 32, box: 'size-8', radius: 'rounded-[var(--radius-size-lg)]' },
  md: { height: 40, box: 'size-10', radius: 'rounded-[var(--radius-size-xl)]' },
  lg: { height: 56, box: 'size-14', radius: 'rounded-[28px]' },
  xl: { height: 72, box: 'size-[72px]', radius: 'rounded-[36px]' },
  '2xl': { height: 96, box: 'size-24', radius: 'rounded-[var(--radius-2xl)]' },
} as const

export type HighlightLogoSize = keyof typeof HIGHLIGHT_LOGO_SIZES

/** The ramp by frame height alone. */
export const HIGHLIGHT_LOGO_HEIGHTS = Object.fromEntries(
  Object.entries(HIGHLIGHT_LOGO_SIZES).map(([step, { height }]) => [step, height]),
) as { [Step in HighlightLogoSize]: (typeof HIGHLIGHT_LOGO_SIZES)[Step]['height'] }
